module.exports = __webpack_public_path__ + "img/bghd.65fbf35a.jpg";